angular.module('gatewayApp').filter('capitalizeFirst', function () {
    return function (input) {
        if (!input) return '';
        input = input.toLowerCase();
        return input.charAt(0).toUpperCase() + input.slice(1);
    };
});